import { z } from "zod";

export const authSchema = z.object({
  email: z
    .string()
    .trim()
    .email({ message: "Bitte geben Sie eine gültige E-Mail-Adresse ein" })
    .toLowerCase(),
  
  password: z
    .string()
    .min(8, { message: "Passwort muss mindestens 8 Zeichen lang sein" })
    .max(72, { message: "Passwort darf maximal 72 Zeichen lang sein" })
    .regex(/[a-z]/, { message: "Passwort muss mindestens einen Kleinbuchstaben enthalten" })
    .regex(/[A-Z]/, { message: "Passwort muss mindestens einen Großbuchstaben enthalten" })
    .regex(/[0-9]/, { message: "Passwort muss mindestens eine Zahl enthalten" }),
});

export type AuthFormData = z.infer<typeof authSchema>;
